module.exports = __webpack_public_path__ + "assets/pdf/E07-en-high-resolution.d971e9ba.pdf";